import { useEffect } from 'react';

import { useWebSocket } from '@contexts/EventsWebSocketProvider';

import Logger from '@util/Logger';

export const useWebSocketEvent = (type: string, handler: (data: any) => void) => {
    const { subscribe, unsubscribe } = useWebSocket();
    const logger = Logger.make('WebSocketEvent');

    useEffect(() => {
        const wrappedHandler = (data: any) => {
            logger.debug(`Received ${type} event:`, data);
            handler(data);
            logger.debug(`Successfully processed ${type} event`);
        };

        subscribe(type, wrappedHandler);
        return () => unsubscribe(type, wrappedHandler);
    }, [type, handler, subscribe, unsubscribe]);
};
